import React, { useState } from 'react';
import { CommentsOutsidePageEditor } from './CommentsOutsidePageEditor.component';

interface CommentsOutsidePageEditProps {
  comment: string;
  isActionVisible: boolean;
  commentId: string;
  handleSave: (options?: { scoreVersionId?: string }) => Promise<unknown>;
  setEditedItemId: (id: string) => void;
  isEnabled?: boolean;
  isCommentRequired?: boolean;
  canEditScore: boolean;
  canDeleteForcedComment: boolean;
}

export const CommentsOutsidePageEdit: React.FC<CommentsOutsidePageEditProps> = ({
  comment,
  isActionVisible,
  commentId,
  handleSave,
  setEditedItemId,
  isEnabled,
  isCommentRequired,
  canEditScore,
  canDeleteForcedComment
}) => {
  return (
    <CommentsOutsidePageEditor
      commentProp={comment}
      onSave={handleSave}
      existingComment={true}
      isActionVisible={isActionVisible}
      rgzId={''}
      commentId={commentId}
      setEditedItemId={(id) => setEditedItemId(id)}
      isEnabled={isEnabled}
      isCommentOnCriterion={isCommentRequired}
      canAddCommentOnCriterion={isCommentRequired}
      canEditScore={canEditScore}
      canDeleteForcedComment={canDeleteForcedComment}
    />
  );
};
